import { Component, OnInit } from '@angular/core';

import { Observable, Subject, Subscription } from 'rxjs';
import { map, switchMap, withLatestFrom } from 'rxjs/operators';

import { SummaryButton, SummaryItems, SummarySplitButton } from 'fc-ui-components';
import { MainNavigationSummaryBarService } from '../main-navigation-summary-bar/main-navigation-summary-bar.service';
import { AutoUnsubscribe } from 'helpers';

@AutoUnsubscribe
@Component({
    selector: 'fc-main-navigation-summary-bar',
    templateUrl: './main-navigation-summary-bar.component.html',
    standalone: false
})
export class MainNavigationSummaryBarComponent implements OnInit {
    show: Observable<boolean>;
    title: Observable<string>;
    hideSummary: Observable<boolean>;
    summary: Observable<SummaryItems>;

    button: Observable<SummaryButton>;
    private buttonSubject = new Subject<void>();
    splitButton: Observable<SummarySplitButton>;
    private splitButtonSubject = new Subject<void>();
    secondaryButton: Observable<SummaryButton>;
    private secondaryButtonSubject = new Subject<void>();
    secondSecondaryButton: Observable<SummaryButton>;
    private secondSecondaryButtonSubject = new Subject<void>();

    subscriptions = new Subscription();

    constructor(private brandShopSummaryBarService: MainNavigationSummaryBarService) {}

    ngOnInit() {
        const configuration = this.brandShopSummaryBarService.getSummaryBarConfig();

        this.show = configuration.pipe(switchMap((config) => config.show));
        this.title = configuration.pipe(map((config) => config.title));
        this.summary = configuration.pipe(switchMap((config) => config.summary));
        this.hideSummary = configuration.pipe(map((config) => config.hideSummary));
        this.button = configuration.pipe(switchMap((config) => config.button));
        this.splitButton = configuration.pipe(switchMap((config) => config.splitButton));
        this.secondaryButton = configuration.pipe(switchMap((config) => config.secondaryButton));
        this.secondSecondaryButton = configuration.pipe(switchMap((config) => config.secondSecondaryButton));

        this.subscriptions.add(
            this.buttonSubject.pipe(withLatestFrom(this.button)).subscribe(([_, button]) => {
                if (button.enabled) {
                    button.action();
                }
            })
        );

        this.subscriptions.add(
            this.secondaryButtonSubject.pipe(withLatestFrom(this.secondaryButton)).subscribe(([_, button]) => {
                if (button.enabled) {
                    button.action();
                }
            })
        );

        this.subscriptions.add(
            this.secondSecondaryButtonSubject
                .pipe(withLatestFrom(this.secondSecondaryButton))
                .subscribe(([_, button]) => {
                    if (button.enabled) {
                        button.action();
                    }
                })
        );

        this.subscriptions.add(
            this.splitButtonSubject.pipe(withLatestFrom(this.splitButton)).subscribe(([_, splitButton]) => {
                if (splitButton.enabled) {
                    splitButton.action();
                }
            })
        );
    }

    onClick() {
        this.buttonSubject.next();
    }

    onSplitButtonClick() {
        this.splitButtonSubject.next();
    }

    onSecondaryClick() {
        this.secondaryButtonSubject.next();
    }

    onSecondSecondaryClick() {
        this.secondSecondaryButtonSubject.next();
    }
}
